export default __webpack_public_path__ + "static/media/fullScreen.4535fd8d.svg";